import React, { useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import AnimatedPage from '@/components/layout/AnimatedPage';
import Footer from '@/components/layout/Footer';
import Navbar from '@/components/layout/Navbar';
import ScrollToTop from '@/components/layout/ScrollToTop';
import AnimatedBlobs from '@/components/ui/AnimatedBlobs';
import Changelog from '@/pages/Changelog';
import EmailVerification from '@/pages/EmailVerification';
import Features from '@/pages/Features';
import Home from '@/pages/Home';
import NotFound from '@/pages/NotFound';
import Privacy from '@/pages/Privacy';
import ResetPassword from '@/pages/ResetPassword';
import Support from '@/pages/Support';
import { appMeta } from '@/config/iphonefastflip';

const WebAppRedirect: React.FC = () => {
  useEffect(() => {
    window.location.replace(appMeta.webUrl);
  }, []);
  return <main className="grid min-h-screen place-items-center text-slate-400">Uruchamianie iPhoneFastFlip…</main>;
};

const AnimatedRoutes: React.FC = () => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<AnimatedPage><Home /></AnimatedPage>} />
        <Route path="/features" element={<AnimatedPage><Features /></AnimatedPage>} />
        <Route path="/changelog" element={<AnimatedPage><Changelog /></AnimatedPage>} />
        <Route path="/privacy" element={<AnimatedPage><Privacy /></AnimatedPage>} />
        <Route path="/support" element={<AnimatedPage><Support /></AnimatedPage>} />
        <Route path="/iphonefastflip" element={<WebAppRedirect />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/email-verification" element={<EmailVerification />} />
        <Route path="/reviews" element={<Navigate to="/" replace />} />
        <Route path="*" element={<AnimatedPage><NotFound /></AnimatedPage>} />
      </Routes>
    </AnimatePresence>
  );
};

const AppContent: React.FC = () => {
  const location = useLocation();
  const standalone = ['/reset-password', '/email-verification', '/iphonefastflip'].includes(location.pathname);

  return (
    <>
      {!standalone && <AnimatedBlobs key={location.pathname} />}
      <ScrollToTop />
      {!standalone && <Navbar />}
      <AnimatedRoutes />
      {!standalone && <Footer />}
    </>
  );
};

const App: React.FC = () => (
  <BrowserRouter>
    <AppContent />
  </BrowserRouter>
);

export default App;
